<template>
  <div>
    <div class="form-content">
      <el-form :model="formdata"
               ref="form"
               label-position="top"
               v-loading="formStatus === 'edit' && update"
               element-loading-text=""
               element-loading-spinner="">
        <form-items v-model="formdata" v-bind:items="datamodel" :editable="editable" :deep="1" :editStatus="editStatus"/>
      </el-form>
	  <div class="bottom-container-margin" style="height: 80px">
	  </div>
	  <div class="bottom-container">
		<el-row type="flex" class="row-bg" justify="space-between">
			<el-col v-if="formStatus && formStatus.indexOf('edit') > -1 && update">
			<el-button class="btn-white-color"
						@click="begUpdate"
						:disabled="disabled"
						round>{{$t('app.update')}}</el-button>
			</el-col>
			<el-col :span="11" v-if="formStatus && formStatus.indexOf('edit') < 0 || !update">
			<el-button class="btn-white-color"
						@click="onSave"
						:disabled="disabled"
						round>{{$t('app.btn_save_draft')}}</el-button>
			</el-col>
			<el-col :span="11" v-if="formStatus && formStatus.indexOf('edit') < 0 || !update">
			<el-button class="btn-black-color"
						@click="onSubmit"
						:disabled="disabled"
						round>{{$t('app.btn_submit')}}</el-button>
			</el-col>
		</el-row>
	  </div>
    </div>
  </div>
</template>
<script>
	import callApp from '@/services/sdk'
	import FormItems from './FormItems'

	import { mapGetters } from 'vuex'
	export default {
		name: 'dynamic-form',
    data() {
			return {
				update: true,
				uploadData: {}
      }
    },
		components: { FormItems },
		props: {
			editable: { type: Boolean },
			value: { type: Object },
			datamodel: { type: Object | Array, required: true }
		},
		mounted() {
		},
		computed: {
			...mapGetters({
        formSet: 'getFormSet',
        formStatus: 'getFormStatus',
        softDataStatus: 'getSoftDataStatus',
        dataPointType: 'getDataPointType'
			}),
			disabled() {
				return (this.formStatus === 'submitedit'
					&& (this.dataPointType === 'collectionUnBind'
						|| this.dataPointType === 'collectionBind')
        || this.softDataStatus === 'disable')
			},
			formdata: {
				get() { return this.value },
				set(formdata) { this.$emit('input', formdata) }
			},
			editStatus() {
				if(this.formStatus && this.formStatus.indexOf('edit') > -1 && this.update) {
					return "watch"
				} else if(this.formStatus && this.formStatus.indexOf('init') > -1) {
					return "init"
				} else if(this.formStatus && this.formStatus.indexOf('edit') > -1) {
					return "edit"
				}
				return "watch"
			}
		},
		methods: {
			begUpdate() {
				this.update = false
	  },
			onSubmit() {
				let forms = this.formSet.slice()
				this.$refs['form'].validate(valid1 => {
					if (valid1) {
						if (forms.length) {
							return this.nestValid(forms)
						} else {
							return this.submit()
						}
					} else {
						return this.$toast({
							message: 'valid fail!',
							position: 'center',
							iconClass: 'icon el-icon-error',
							duration: '3000'
						})
					}
				})
			},
		filterData(source) {
			if (source == undefined) {
				return
			}
			const keys = Object.keys(source)
			for (let i = 0; i < keys.length; i++) {
				if (!(source[keys[i]] instanceof Array) && typeof source[keys[i]] === 'object') {
					this.filterData(source[keys[i]])
				}
				if (source[keys[i]] instanceof Array && source[keys[i]].length <= 0) { // list
					source[keys[i]] = []
				}
				if (source[keys[i]] instanceof Array && source[keys[i]].length) { // list

				let filteredItemdata = source[keys[i]].filter(item=>{
						if (typeof item !== 'object') {
							return true
						}
						var keys = Object.keys(item)
						if (keys.length <= 0) {
							return true
						}
						var empty = false
						keys.forEach(key=>{
							var origin_empty = empty
							if(item[key] != undefined) {
								empty = true
							}
							if(typeof item[key] === 'string' && item[key].length <= 0) {
								empty = origin_empty
							}
						})
						return empty
					})
					source[keys[i]] = filteredItemdata
				}
			}
		},
      submit() {
		  		this.uploadData = JSON.parse(JSON.stringify(this.formdata))
		  		this.filterData(this.uploadData)
				callApp('getData', {
					type: `dataSource.server.submit`,
					data: this.uploadData
				}, 'cbGetData')
      },
      save() {
				this.uploadData = JSON.parse(JSON.stringify(this.formdata))
				this.filterData(this.uploadData)
				return callApp('getData', {
					type: `dataSource.server.save`,
					data: this.uploadData
				}, 'cbGetData')
      },
			onSave() {
				let forms = this.formSet.slice()
				this.$refs['form'].validate(valid1 => {
					if (valid1) {
						if (forms.length) {
							return this.nestValid(forms, 'save')
						} else {
							this.save()
						}
					} else {
						return this.$toast({
							message: 'valid fail!',
							position: 'center',
							iconClass: 'icon el-icon-error',
							duration: '3000'
						})
					}
				})
			},
			nestValid(form, type) {
				form[0] && form[0].validate && form[0].validate(valid2 => {
					if (valid2) {
						form.splice(0, 1)
						if (!form.length) {
							if (type === 'save') return this.save()
							return this.submit()
						}
						this.nestValid(form, type)
					} else {
						form[0].$emit("showValidFail")
						return this.$toast({
							message: 'valid fail!',
							position: 'center',
							iconClass: 'icon el-icon-error',
							duration: '3000'
						})
					}
				})
			}
		}
	}
</script>

<style lang='scss' scoped>
  .form-title {
    font-size: 1.5em;
  }
  .el-loading-mask {
    background-color: transparent !important;
  }
  .el-loading-mask .el-loading-spinner {
    visibility: hidden;
  }
  .bottom-container {
	  bottom: 0px;
	  padding: 10px;
	  /* display: flex; */
	  /* align-items: center; */
	  left: 0px;
	  right: 0px;
	  height: 80px;
	  position: fixed;
	  background-color: rgba(255,255,255,0.8);
	  z-index: 1002
  }
</style>
